// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"6b2aff47","232":"545fab4d","237":"f1e25f91","526":"26842804"}[chunkId] + ".chunk.js";
};